<template>
    <validation-provider :name="$attrs.name" :rules="$attrs.rules"
                         v-slot="{ errors }">
        <label :for="$attrs.name" class="form-label-control" v-text="$attrs.label"></label>
        <div class="d-flex mb-3">
            <input :id="$attrs.id"
                   :type="$attrs.type"
                   class="form-control"
                   :placeholder="$attrs.placeholder"
                   @input="(e) => $emit('input', e.target.value)"
                   :class="{'is-invalid': errors[0] ? errors[0] : errorFn}"
                   :name="$attrs.name"
                   v-model="value"
                   :disabled="isLoading"
                   autofocus>
            <div :class="'input-group-append align-items-center d-flex p-1 ' + (!isLoading ? 'd-none' : '') ">
                <div class="spinner-border spinner-border-sm" role="status">
                    <span class="sr-only"></span>
                </div>
            </div>
        </div>
        <div class="form-text text-sm text-danger p-0" v-cloak>
            {{ errors[0] ? errors[0] : errorFn }}
        </div>
    </validation-provider>
</template>
<script>
export default {
    name: 'Input',
    props: {
        isLoading: false,
        initialValue: {
            default: null
        },
        error: {
          default: null
        }
    },
    data() {
        return {
            value: this.initialValue,
            errorFn: this.error
        }
    },
    watch: {
        value() {
            this.errorFn = null
        }
    }

}
</script>
